import {ScrollController} from "./controller.js";
import {CarouselItem} from "./item.js";
import {ABSHtmlElement} from "../abstract/ABSHtmlElement.js";
export class Carousel extends ABSHtmlElement{
    private controller = new ScrollController(this);
    private lastX: number = 0;
    private buttons?: {leftButton: JQuery; rightButton: JQuery}
    public set loading(value: boolean){
        // $(this).css('visibility', value?'hidden':'visible')
        if(value) $(this).addClass('loading-animation');
        else $(this).removeClass('loading-animation');
        for (const el of this.children as unknown as CarouselItem[])
            el.style.visibility=value?'hidden':'visible';
        this.buttons?.leftButton?.css('visibility', value?'hidden': 'visible');
        this.buttons?.rightButton?.css('visibility', value?'hidden': 'visible');
        $(this).parent().children('.spinner').css('display', value?'':'none')
    }

    constructor() {
        super();

        $(()=>{
            this.show();
            for(let i of this.children as unknown as CarouselItem[])
                i.formatText();
            this.buttons = {
                leftButton:
                    $('<button class="bordered-left slick-next slick-arrow" aria-label="Next" type="button"><i class="far fa-angle-right"></i></button>')
                        .on('click', () => this.controller.scrollNext())
                        .appendTo($(this.parentElement!)),
                rightButton:
                    $('<button class="bordered-right slick-prev slick-arrow" aria-label="Previous" type="button"><i class="far fa-angle-left"></i></button>')
                        .on('click', () => this.controller.scrollPrev())
                        .prependTo($(this.parentElement!))
            };
            this.blocked = this.blocked;
        });
        $(this)
            .on('mousedown', (e)=> {
                if(!this.blocked)
                    this.controller.startMove(e.pageX)
            })
            .on('touchstart', e=>{
                if(!this.blocked)
                    this.controller.startMove(e.originalEvent!.touches[0].pageX)
            })
            .on('mouseover', ()=>{
                this.controller.hovered=true;
            })
            .on('mouseout', ()=>{
                this.controller.hovered=false;
                this.controller.updateTimeout();
            })
        $(document)
            .on('mousemove', (e)=>{
                if(!this.controller.scrollByUserData) return;
                e.preventDefault();
                this.touchMove(e.pageX)
            })
            .on('touchmove', (e)=>{
                e.preventDefault();
                e.stopPropagation();
                this.touchMove(e.originalEvent!.touches[0].pageX)
            })
            .on('click', (e)=>{
                if(!this.controller.scrollByUserData) return;
                const delta = e.originalEvent!.pageX - this.controller.scrollByUserData.startXPos;
                if((+new Date) - this.controller.scrollByUserData.when >= 180 || Math.abs(delta) > 10) {
                    e.preventDefault();
                    e.stopPropagation();
                }
                this.controller.end(delta);
            })
            .on('mouseup', e=>{
                //Sometimes click doesn't trigger (for example in firefox and it freezes)
                setTimeout( () =>{
                    if(!this.controller.scrollByUserData) return;
                    const delta = e.originalEvent!.pageX - this.controller.scrollByUserData.startXPos;
                    this.controller.end(delta);
                }, 10)
            })
            .on('touchend', (e) =>{
                if(!this.controller.scrollByUserData) return;
                const delta = e.originalEvent!.changedTouches[0].pageX - this.controller.scrollByUserData.startXPos;
                this.controller.end(delta);
            })
            .on('blur mouseleave', ()=>{
                if(this.controller.scrollByUserData)
                    this.controller.end(this.lastX-this.controller.scrollByUserData.startXPos)
            })
        $(window)
            .on('resize', ()=>{
                this.controller.end(0)
            })
        this.onAttributeChange("blocked", (old, value)=>this.blocked=value==='blocked')
            .onAttributeChange('anim-time', (old, value) => {
                const val = +value;
                if(!Number.isNaN(val))
                    this.controller.animationTimeoutTime = val;
            })
    }

    private touchMove(x: number){
        this.lastX = x;
        if(!this.controller.scrollByUserData) return;
        this.scrollX(this.controller.currentScroll +
            x - this.controller.scrollByUserData.startXPos
        )
        setTimeout(()=>{
            if(!this.controller.scrollByUserData) return;
            this.controller.end(x - this.controller.scrollByUserData.startXPos, false);
            this.controller.startMove(x, (+new Date) - 200);
        }, 200)

    }
    private show(){
        this.loading = false;
        $(this)
            // .css('width',  this.width+"px")
            .css('height',  $(this.children[0]).height()+"px");
        this.scrollX(0);
    }
    get wrapperWidth(): number{
        return $(this.parentElement!).width()! as number;
    }
    scrollX(positionX: number){
        for (let i of this.children as unknown as CarouselItem[]){
            try {
                i.updatePosition(positionX);
            }catch (e){
                console.error(e);
            }
        }
    }
    get width(){
        return this.blockWidth * this.childElementCount
    }
    connectedCallback() {
        try {
            const observer = new MutationObserver(mutationsList => {
                for (const mutation of mutationsList) {
                    if (mutation.type === 'childList') {
                        // setTimeout(()=> {
                        for (const el of this.children as unknown as CarouselItem[])
                            el?.forceUpdateIndex();
                        this.scrollX(this.controller.currentScroll)
                        // }, 0);
                        // mutation.addedNodes.forEach(node => {});
                    }
                }
            });
            observer.observe(this, {childList: true});
        }catch(e){
            console.error(e);
        }
        $(document).on('keyup', this.onKeyDown);

    }

    protected disconnectedCallback() {
        super.disconnectedCallback();
        $(document).off('keyup', this.onKeyDown)

    }

    onKeyDown = (ev: JQuery.KeyUpEvent) =>{
        if((document.activeElement?.tagName ?? 'BODY') === 'BODY' && $(this).isInViewport()){
            if(ev.key === "ArrowLeft"){
                this.controller.scrollPrev();
            }
            else if(ev.key === "ArrowRight"){
                this.controller.scrollNext();
            }

        }
    }

    public get blockWidth() {return (this.children[0] as CarouselItem).width;}
    public get blocksCountInRow(){return Math.max(Math.floor(this.wrapperWidth / this.blockWidth), 1);}
    static observedAttributes = ['blocked', 'anim-time'];
    private set blocked(value: boolean) {
        if(this.blocked != value) this.setAttribute('blocked', value?'blocked':'');
        if(value) {
            this.buttons?.rightButton?.css('display', 'none');
            this.buttons?.leftButton?.css('display', 'none');
        }
        else{
            this.buttons?.rightButton?.css('display', '');
            this.buttons?.leftButton?.css('display', '');
        }
    }
    private get blocked(){
        return this.getAttribute('blocked') === 'blocked';
    }
}
